import "./hero.css"
const Hero = () => {
    return ( 
        <div className="flex  ml-36 mt-12 items-center ">
          <p className="text-7xl  text-white  tracking-wider uppercase border border-white p-4 mt-20 pr-12">Immersive <br></br> experiences <br></br> that deliver</p>
        </div>
     );
}
 
export default Hero;